import React, { useEffect, useState } from "react"
import Link from "./link"

const isPartiallyActive = ({ isCurrent, isPartiallyCurrent, to }) => {
  const isHome = to === '/' || to.includes('/features')
  return (isPartiallyCurrent && !isHome) || (isCurrent && isHome) ? `btn active` : `btn`
}

function PartialNavLink(props) {
	return <Link className={isPartiallyActive(props)} {...props} />
}

export default function Header(props) {

	const isDefault = props.location?.pathname.includes('/features/') || props.location?.pathname === '/'

  const [isTop, setIsTop] = useState(true)

  const onScroll = e => {
    const offset = window.pageYOffset || document.documentElement.scrollTop

    if (offset > 50) {
      setIsTop(false)
    } else if (offset <= 50) {
      setIsTop(true)
    }
  }

  useEffect(() => {
    onScroll()
    window.addEventListener('scroll', onScroll, false)
    return () => {
      window.removeEventListener('scroll', onScroll, false)
    }
  }, [])

  return (
    <nav className={!isTop ? "is-scrolling" : ""}>
			<div className="container">
				<Link to="/" className={`btn ${!isDefault || 'active'}`}>hoverstat.es</Link>
				<PartialNavLink to="/archive">Archive</PartialNavLink>
				<PartialNavLink to="/submit">Submit</PartialNavLink>
				<PartialNavLink to="/about">?</PartialNavLink>
			</div>
		</nav>
  )
}
